import { Suspense, useState } from 'react';
import { Box, Paper } from '@mui/material';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import { FiltrosComponent } from '../components/filtrosComponent';
import { SeccionDividendosComponent } from '../components/seccionDividendosComponent';

const breadcrumbItems = [
  { label: 'Inicio', url: '/' },
  { label: 'Reportes', url: `/reportes`, active: true },
  { label: 'Consultar dividendos mes', active: true },
];

function DividendosMes() {

  const [mes, setMes] = useState<number>(new Date().getMonth() + 1);
  const [anio, setAnio] = useState<number>(new Date().getFullYear());

  const handleFilter = (month: number, year: number) => {
    setMes(month);
    setAnio(year);
  }

  return (
    <>
      <Suspense>
        <Breadcrumb items={breadcrumbItems} />
        <Box sx={{ mt: 2 }}>
          <Paper elevation={3} sx={{ p: 3 }}>
            <Suspense>

              <FiltrosComponent handleFilter={handleFilter} />

              {mes && anio && (
                <SeccionDividendosComponent
                  key={`${mes}-${anio}-${true}`}
                  title='Dividendos Cuadrados'
                  nameFile='DIVIDENDOSCUADRADOS'
                  month={mes}
                  year={anio}
                  cuadrado={true}
                />
              )}

              {mes && anio && (
                <SeccionDividendosComponent
                  key={`${mes}-${anio}-${false}`}
                  title='Dividendos No Cuadrados'
                  nameFile='DIVIDENDOSNOCUADRADOS'
                  month={mes}
                  year={anio}
                  cuadrado={false}
                />
              )}

            </Suspense>
          </Paper>
        </Box>
      </Suspense>
    </>
  );
}

export default DividendosMes;
